import {AppState} from '../../configStore';

export const selectSettingDataInStoreAccordingToApiResponse = (state: AppState) =>
  state.settingDataInStoreAccordingToApiResponse;
